import {
  CopyOutlined,
  DeleteOutlined,
  SettingOutlined
} from "@ant-design/icons"
import { Flex, type TableColumnsType, Typography } from "antd"
import type { ItemType } from "antd/es/menu/interface"
import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"
import type { TFunction } from "react-i18next"

import { RowActionsMenu } from "../../../../../components/EntityTable/RowActionsMenu.tsx"
import { empty } from "../../../../../constants/placeholders"
import type { ProjectTypeTemplate } from "../../../types/project-type.types.ts"

dayjs.extend(relativeTime)

interface GetColumnsArgs {
  t: TFunction
  onSelectRow: (record: ProjectTypeTemplate, action: string) => void
  //
  deleteAllowed?: boolean
  copyAllowed?: boolean
  editAllowed?: boolean
}

export const getColumns = ({
  t,
  onSelectRow,
  copyAllowed,
  editAllowed,
  deleteAllowed
}: GetColumnsArgs): TableColumnsType<ProjectTypeTemplate> => [
  {
    title: "Template Name",
    dataIndex: "name",
    key: "name",
    width: 200,
    render: (name: string) => (
      <Flex vertical gap={4} align={"start"}>
        <Typography.Text ellipsis={{ tooltip: name }} className={"font-bold"}>
          {name}
        </Typography.Text>
        {/*<Tag color={record?.is_active ? "green" : "red"}>*/}
        {/*  {name ? "Active" : "Inactive"}*/}
        {/*</Tag>*/}
      </Flex>
    )
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    render: (_) => (
      <Typography.Paragraph ellipsis={{ rows: 3, tooltip: _ }}>
        {_ || empty}
      </Typography.Paragraph>
    )
  },

  {
    title: "Milestones",
    dataIndex: "phases_count",
    key: "phases_count",
    width: 120,
    render: (_: number) => {
      const count = _ || 0
      return `${count} milestone${count === 1 ? "" : "s"}`
    }
  },
  {
    title: "Last Updated",
    sorter: false,
    dataIndex: "updated",
    key: "updated",
    width: 145,
    render: (value: string) => {
      return (
        <Typography.Text type={"secondary"}>
          {/*{dayjs(value).fromNow()}*/}
          {value}
        </Typography.Text>
      )
    }
  },
  // Deliberately keyless: `applyConfig` treats a column with no key as an
  // always-visible passthrough pinned to the end, which is what keeps this one
  // out of the saved layout and out of reach of the reorder handles.
  {
    title: t("settingsProjectTemplates.column.actions"),
    sorter: false,
    className: "text-center",
    width: 85,
    hidden: !editAllowed && !copyAllowed && !deleteAllowed,
    fixed: "right",
    render: (_, record) => {
      const items = [
        {
          key: "1",
          label: "Edit",
          hidden: !editAllowed,
          onClick: () => onSelectRow(record, "edit"),
          icon: <SettingOutlined />
        },
        {
          key: "2",
          label: "Copy",
          hidden: !copyAllowed,
          onClick: () => onSelectRow(record, "copy"),
          icon: <CopyOutlined />
        },
        {
          key: "3",
          label: "Delete",
          hidden: !deleteAllowed,
          onClick: () => onSelectRow(record, "delete"),
          icon: <DeleteOutlined />
        }
      ] as Array<ItemType & { hidden?: boolean }>

      return <RowActionsMenu items={items} placement="bottomRight" />
    }
  }
]
